import type {
  FullscriptConnectResponse,
  FullscriptConnectionStatus,
  FullscriptDisconnectResponse,
  FullscriptEmbedSessionResponse,
  FullscriptPatientLinkResponse,
  FullscriptPatientUnlinkResponse,
  FullscriptTreatmentPlanListResponse,
} from "@/types/fullscript";

import { requestData } from "@/api/api-config";

export async function connectFullscript(): Promise<FullscriptConnectResponse | null> {
  return await requestData<FullscriptConnectResponse>(
    "fullscript/connect",
    "post",
    undefined,
    false,
  );
}

export async function fetchFullscriptStatus(): Promise<FullscriptConnectionStatus | null> {
  return await requestData<FullscriptConnectionStatus>(
    "fullscript/status",
    "get",
    undefined,
    false,
  );
}

export async function disconnectFullscript(): Promise<FullscriptDisconnectResponse | null> {
  return await requestData<FullscriptDisconnectResponse>(
    "fullscript/disconnect",
    "post",
    undefined,
    false,
  );
}

export async function createFullscriptEmbedSession(
  patientId: string,
): Promise<FullscriptEmbedSessionResponse | null> {
  return await requestData<FullscriptEmbedSessionResponse>(
    `fullscript/patients/${patientId}/embed-session`,
    "get",
    undefined,
    false,
  );
}

export async function linkFullscriptPatient(
  patientId: string,
  fullscriptPatientId: string,
): Promise<FullscriptPatientLinkResponse | null> {
  return await requestData<FullscriptPatientLinkResponse>(
    `fullscript/patients/${patientId}/link`,
    "post",
    {
      json: { fullscriptPatientId },
    },
    false,
  );
}

export async function unlinkFullscriptPatient(
  patientId: string,
): Promise<FullscriptPatientUnlinkResponse | null> {
  return await requestData<FullscriptPatientUnlinkResponse>(
    `fullscript/patients/${patientId}/unlink`,
    "post",
    undefined,
    false,
  );
}

export async function fetchFullscriptTreatmentPlans(
  patientId: string,
): Promise<FullscriptTreatmentPlanListResponse | null> {
  return await requestData<FullscriptTreatmentPlanListResponse>(
    `fullscript/patients/${patientId}/treatment-plans`,
    "get",
    undefined,
    false,
  );
}

export async function syncFullscriptTreatmentPlans(
  patientId: string,
): Promise<FullscriptTreatmentPlanListResponse | null> {
  return await requestData<FullscriptTreatmentPlanListResponse>(
    `fullscript/patients/${patientId}/treatment-plans/sync`,
    "post",
    undefined,
    false,
  );
}
